import React from 'react';
// import Helpers from './Helpers.js'

import './TotalInfo.css';


class TotalInfo extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
		   barMode: this.props.barMode
		}
	}

	labels = {
		electors: "Elektoren",
		votes: "Stimmen"
	}


	render() {
		let winnerStyle = "";
		if(this.props.parties.o.hasOwnProperty(this.props.infoKey) && this.props.candidates.o.hasOwnProperty(this.props.parties.o[this.props.infoKey].ticket.president)) {
			if(this.props.candidates.o[this.props.parties.o[this.props.infoKey].ticket.president].winner*1===1) {
				winnerStyle = "winner"
			}
			return(
				<div className={'TotalInfo '+this.props.styleName+" "+winnerStyle}>
					<div className='portrait-box'>
						<img 
								className={'totals-portrait '+this.props.infoKey}
								src = { "./pics/candidates/"+this.props.candidates.o[this.props.parties.o[this.props.infoKey].ticket.president].portrait+".jpg" }
								alt = { this.props.parties.o[this.props.infoKey].ticket.president }
							>
						</img>						
						<img 
								className={'party-marker party-marker-'+this.props.infoKey}
								src = { "./pics/parties/"+this.props.parties.o[this.props.infoKey].partycode+".png" }
								alt = ""
							>
						</img>
							{winnerStyle==="winner"
								? <div className='winner-seal'></div>
								: false
							}
							
							
					</div>
					<h6>{this.props.parties.o[this.props.infoKey].ticket.president}</h6>
					<div className='party-word'>{this.props.label}</div>
				</div> 	
			)			
		}
		else {
			return(
				false
			)
		}
	}
}

export default TotalInfo
